import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { connect } from 'react-redux';
import s from './lightbox.scss';

import { districtsWithGraveyards } from '../../../constants';

class Lightbox extends React.Component {

  closeModal = () => {
    this.props.closeLightbox();
  }

  render() {
    const imgAddr = `${process.env.GEOSERVER}/wms?REQUEST=GetLegendGraphic&VERSION=1.0.0&FORMAT=image/png&LAYER=${this.props.district.prefix}:${this.props.layerName}`;

    return (
      <div id="legendModal" className="legend">
        <span className="closeLegend" onClick={this.closeModal}>&times;</span>
        <span className="zoom-in" onClick={this.closeModal}>&times;</span>
        <div className="modal-content">

          <div className="legendSlide">
            {districtsWithGraveyards.includes(this.props.district.prefix) ? <img width={800} height={800} src={`${process.env.OLD_IHUB}/static/legenda_cmentarz.png`} alt="Legenda"/> : null }
            {this.props.district.prefix === 'krosno' ? <img width={800} height={800} src={`${process.env.OLD_IHUB}/upload/legenda_krosno_plan.png`} alt="Legenda" /> : null }
            {this.props.district.prefix === 'gmina_cieszanow' ? <img width={800} height={800} src={`${process.env.OLD_IHUB}/upload/legenda_gmina_cieszanow_plan.png`} alt="Legenda" /> : null}
          </div>

        </div>
      </div>
    );
  }
}

const mapState = state => ({
  district: state.district.district,
});

export default withStyles(s)(connect(mapState)(Lightbox));



// WEBPACK FOOTER //
// src/components/Modals/LayersModal/Lightbox.js